import ButtonCta from '@components/atoms/button-cta'
import Image from '@components/atoms/image'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import { RenderRichText } from '@components/renderers'
import useStyles from './document-spotlight.styles'

const DocumentSpotlight = (props) => {
  const {
    heading,
    supportiveCopyRich,
    buttonLabel,
    image,
    document,
  } = props
  const styles = useStyles()

  const SupportiveCopy = () => (
    <>
      {supportiveCopyRich && (
        <div className={styles.subtitle}>
          <RenderRichText {...supportiveCopyRich} />
        </div>
      )}
    </>
  )

  return (
    <Box bgcolor="common.white" pt={[5, 5]} pb={[4, 4, 8]}>
      <Container className={styles.root}>
        <div className={styles.gridContainer}>
          <div className={styles.textWrapper}>
            <div>
              {heading && (
                <div className={styles.headline}>
                  <Typography variant="h3">
                    {heading}
                  </Typography>
                </div>
              )}
              <SupportiveCopy />
            </div>
            {buttonLabel && document && (
              <ButtonCta
                variant="contained"
                color="primary"
                externalLink={document.url}
              >{buttonLabel}
              </ButtonCta>
            )}
          </div>
          {image && (
            <Image
              className={styles.spotlightImage}
              src={image?.url}
              alt={image?.description}
            />
          )
          }
        </div>
      </Container>
    </Box>
  )
}

DocumentSpotlight.propTypes = {
  heading: PropTypes.string,
  supportiveCopyRich: PropTypes.object,
  buttonLabel: PropTypes.string,
  image: PropTypes.object,
  document: PropTypes.object,
}

DocumentSpotlight.defaultProps = {}

export default DocumentSpotlight
